import { render } from "./SidePanel.vue?vue&type=template&id=3cd42766&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"

import "./SidePanel.vue?vue&type=style&index=0&id=3cd42766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd42766"]])

export default __exports__